<template>
  <div>
    <the-button-back />
    <form-component />

    <button-update />
  </div>
</template>

<script>
import TheButtonBack from '@/lib/TheButtonBack'
import FormComponent from './FormComponent/index'
import ButtonUpdate from './ButtonUpdate'

export default {
  components: {
    TheButtonBack,
    FormComponent,
    ButtonUpdate
  }
}
</script>
